export default __webpack_public_path__ + "static/media/Ajit Narayan Mohanty.7fc2262f.JPG";